<div class="flex flex-row">
  <div class="flex-grow space-y-4">
    @for (item of data.items; track $index; let isLast = $last) {
      <div class="flex flex-row">
        <div class="flex mr-2">
          @if (data.type === 'error') {
            <mat-icon
              class="text-current"
            svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
          }
          @if (data.type === 'success') {
            <mat-icon
              class="text-current"
            svgIcon="heroicons_outline:check-circle"></mat-icon>
          }
          @if (data.type === 'warning' || data.type === 'info') {
            <mat-icon
              class="text-current"
            svgIcon="heroicons_outline:information-circle"></mat-icon>
          }
        </div>
        <div class="flex flex-col flex-grow justify-start pr-8">
          <span class="text-current font-bold" style="line-height: 24px;">
            {{ item.title }}@if (item.code) {
            <span>: {{ item.code }}</span>
          }
        </span>
        @if (item.detail) {
          <div class="text-current">{{ item.detail }}</div>
        }
        @if (item.value) {
          <div class="text-current">{{ item.value }}</div>
        }
        @if (item.id) {
          <div class="text-current text-sm italic color">({{ item.id }})</div>
        }
        @if (item.action) {
          <div>
            <button (click)="item.action.callbackFn()" mat-flat-button color="accent">{{ item.action.label }}</button>
          </div>
        }
      </div>
    </div>
  }
</div>
<div class="absolute top-4 right-4">
  <button class="-mt-2 -mr-2" mat-icon-button (click)="dismiss()">
    <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
  </button>
</div>
</div>
